module.exports = __webpack_public_path__ + "img/2.1b0aa9ca.svg";